// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import SortSvg from '../icons/direction/Sort';
var Sort = createSvgIcon({
    as: SortSvg,
    ariaLabel: 'sort',
    category: 'direction',
    displayName: 'Sort'
});
export default Sort;
